export const VISIT_SITUATIONS = [
    {label:"Aberto", value:"Aberto"},
    {label:"Fechado", value:"Fechado"},
    {label:"Recusa", value:"Recusa"},
    {label:"Recuperação", value:"Recuperação"},
    {label:"Orientação", value:"Orientação"},
];